module.exports = __webpack_public_path__ + "static/media/react.84287d09.svg";